import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker, InfoWindow } from 'react-google-maps';

import ImgFaseGrey from '../image/traffic-grey.png';
import ImgFaseGreen from '../image/traffic-green.png';
import ImgFaseYellow from '../image/traffic-yellow.png';
import ImgFaseRed from '../image/traffic-red.png';
import GifTrafficYellowBlink from '../image/traffic-yellow-blink.gif';

import ImgPedestrianGrey from '../image/pedestrian-grey.png';
import ImgPedestrianGreen from '../image/pedestrian-green.png';
import ImgPedestrianYellow from '../image/pedestrian-yellow.png';
import ImgPedestrianRed from '../image/pedestrian-red.png';
import GifPedestrianRedBlink from '../image/pedestrian-red-blink.gif';

import Content from '../common/template/content';
import { getConfig } from '../configuracao/configLocal';
import { downloadCroqui } from '../controlador/controladorActions';
import { Button } from 'react-bootstrap';

import {
  getControladorFase,
  getControladorCoresGF,
  getControladorCoresGT,
  getInicioMapa,
  getPluviometroMapaData,
} from './faseActions';
import {
  getConfControladorGrupoList,
  getGrupoFisicoPluviometroList,
  getConfControladorGrupoPluviometroList,
} from '../common/selectdb/selectdbAtions';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import SelectConfGrupoFisicoPluviometro from '../common/selectdb/selectConfGrupoFisicoPluviometro';
import swal from 'sweetalert2';
import ContentHeader from '../common/template/contentHeader';
import SelectConfigTraffic from '../common/selectdb/selectConfigTraffic';
import CloudIcon from './CloudIcon';
import CloudOverlay from './CloudOverlay';
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const COR_FASE_MAP = {
  Vermelho: '#e53935',
  Amarelo: '#fdd835',
  Verde: '#43a047',
  Apagado: '#9e9e9e',
};

const COR_BORDA_MAP = {
  Vermelho: '#8e0000',
  Amarelo: '#c6a700',
  Verde: '#1b5e20',
  Apagado: '#616161',
};

function parseSetasValue(value, posicaoIdx = 0) {
  let parsed = [];
  try {
    if (value) parsed = typeof value === 'string' ? JSON.parse(value) : value;
  } catch (_) {}
  if (!Array.isArray(parsed)) return [];

  // Se é array de arrays (novo formato), usar posição específica
  if (parsed.length > 0 && Array.isArray(parsed[0])) {
    parsed = parsed[posicaoIdx] || [];
  }
  // Se é array simples (formato antigo), usar diretamente

  return parsed.filter(s => s && s.angulo !== undefined && s.angulo !== null);
}

// Converte ângulo cartesiano (0°=Leste, 90°=Norte) para rotação SVG (0°=cima)
function cartToSvg(ang) {
  return 90 - ang;
}

// Transforma pontos locais (relativos ao centro, com rotação) para coordenadas absolutas SVG
function transformPoints(points, angDeg, cx, cy) {
  const rad = (angDeg * Math.PI) / 180;
  const cos = Math.cos(rad),
    sin = Math.sin(rad);
  return points.map(([x, y]) => [cx + x * cos - y * sin, cy + x * sin + y * cos]);
}

// Gera um sub-path SVG (M...L...Z) a partir de pontos absolutos
function pointsToPath(pts) {
  return 'M' + pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L') + ' Z';
}

function buildArrowMarkerSvg(setas, color, bidirecional, strokeColor) {
  const getAng = s => (s.angulo !== '' && s.angulo != null ? Number(s.angulo) : 0);
  const sc = strokeColor || 'white';
  const sa = `stroke="${sc}" stroke-width="3" stroke-linejoin="round" paint-order="stroke"`;
  const cx = 48,
    cy = 48;

  const arrowFullPts = [[-3.5, 22], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 22]];
  const tailPts = [[-3.5, 30], [-3.5, 0], [3.5, 0], [3.5, 30]];
  const headPts = [[-3.5, 0], [-3.5, -12], [-11, -12], [0, -28], [11, -12], [3.5, -12], [3.5, 0]];

  // Bidirecional (pedestre): todas as setas são pontas completas
  if (bidirecional) {
    let combinedD = '';
    for (let i = 0; i < setas.length; i++) {
      const svgAng = cartToSvg(getAng(setas[i]));
      combinedD += (i > 0 ? ' ' : '') + pointsToPath(transformPoints(arrowFullPts, svgAng, cx, cy));
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
  }

  const svgAng0 = cartToSvg(getAng(setas[0]));

  if (setas.length === 1) {
    const d = pointsToPath(transformPoints(arrowFullPts, svgAng0, cx, cy));
    return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${d}" fill="${color}" ${sa}/></svg>`;
  }

  const tailSvgAng = svgAng0 + 180;
  let combinedD = pointsToPath(transformPoints(tailPts, tailSvgAng, cx, cy));

  const destinos = setas.slice(1);
  for (let i = 0; i < destinos.length; i++) {
    const destSvgAng = cartToSvg(getAng(destinos[i]));
    combinedD += ' ' + pointsToPath(transformPoints(headPts, destSvgAng, cx, cy));
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" overflow="visible"><path d="${combinedD}" fill="${color}" ${sa} fill-rule="nonzero"/></svg>`;
}

const arrowIconCache = new Map();
function getArrowIconSize(zoom) {
  if (zoom >= 20) return 96;
  if (zoom >= 19) return 80;
  if (zoom >= 18) return 64;
  if (zoom >= 17) return 48;
  if (zoom >= 16) return 36;
  if (zoom >= 15) return 28;
  if (zoom >= 14) return 22;
  if (zoom >= 13) return 16;
  return 12;
}

function getArrowIcon(setasValue, corFase, zoom, bidirecional) {
  const setas = parseSetasValue(setasValue);
  if (!setas.length) return null;
  const color = COR_FASE_MAP[corFase] || COR_FASE_MAP.Apagado;
  const strokeColor = COR_BORDA_MAP[corFase] || COR_BORDA_MAP.Apagado;
  const sz = getArrowIconSize(zoom || 15);
  const key = `${color}|${strokeColor}|${sz}|${bidirecional ? 'bi' : 'dir'}|${JSON.stringify(setas)}`;
  const cached = arrowIconCache.get(key);
  if (cached) return cached;
  const svg = buildArrowMarkerSvg(setas, color, bidirecional, strokeColor);
  const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  let icon = { url };
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    icon = {
      url,
      scaledSize: new window.google.maps.Size(sz, sz),
      anchor: new window.google.maps.Point(sz / 2, sz / 2),
    };
  }
  arrowIconCache.set(key, icon);
  return icon;
}

function getArrowMarkerShape(zoom) {
  const sz = getArrowIconSize(zoom || 15);
  const half = Math.round(sz / 2);
  const radius = Math.max(5, Math.round(sz * 0.22));
  return {
    type: 'circle',
    coords: [half, half, radius],
  };
}

class MapaFaseGeral extends Component {
  constructor(props) {
    super(props);

    let grupo = getConfig('grupo');
    this.props.getInicioMapa(grupo).then(response => {
      if (parseInt(response.payload.data.latitude) === 1) {
        swal({
          type: 'warning',
          title: 'Grupo físico sem controlador cadastrado!',
        });
      }
      this.setState({ inicioMapa: this.props.inicioMapa });
    });

    // Carregar dados iniciais dos controladores
    this.props.getControladorCoresGF(grupo);
    this.renderMarker = this.renderMarker.bind(this);
    this.handleToggleClose = this.handleToggleClose.bind(this);
    this.renderInfoWindow = this.renderInfoWindow.bind(this);
    this.renderStreetViewTooltip = this.renderStreetViewTooltip.bind(this);
    this.changeGrupo = this.changeGrupo.bind(this);
    this.changeDisplayTraffic = this.changeDisplayTraffic.bind(this);
    this.changeVisualizacao = this.changeVisualizacao.bind(this);
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
    this.onMapLoad = this.onMapLoad.bind(this);

    this.state = {
      openInfoWindowMarkerId: '',
      loop: 0,
      intervaloMapaFaseGeral: [],
      listContMap: [],
      loopList: [],
      inicioMapa: {},
      displayTraffic: false,
      mapZoom: 15,
      blinkOn: true,
      tipoVisualizacao: props.visualizacao || 'fases', // Usa prop ou padrão 'fases'
      pluviometroData: [],
      pluviometroDataAnterior: [], // Para manter dados anteriores durante "hold"
      googleMapsReady: typeof window !== 'undefined' && !!(window.google && window.google.maps),
      isStreetView: false,
      selectedMarkerData: null,
    };
  }

  // Método para processar dados pluviométricos com lógica de "hold"
  processarDadosPluviometricos(novosDados) {
    const dadosAnteriores = this.state.pluviometroDataAnterior || [];

    return novosDados.map(novoItem => {
      // Encontrar item correspondente nos dados anteriores
      const itemAnterior = dadosAnteriores.find(anterior => anterior.controlador_id === novoItem.controlador_id);

      // Se o período usado é "15min_hold", manter dados anteriores se existirem
      if (novoItem.periodo_usado === '15min_hold' && itemAnterior) {
        return {
          ...novoItem,
          // Manter visualização anterior para evitar mudanças bruscas
          chuva_display: itemAnterior.chuva_display || novoItem.chuva_display,
          intensidade_chuva: itemAnterior.intensidade_chuva || novoItem.intensidade_chuva,
          cor_intensidade: itemAnterior.cor_intensidade || novoItem.cor_intensidade,
        };
      }

      // Caso contrário, usar os novos dados
      return novoItem;
    });
  }

  componentDidMount() {
    if (!this.state.googleMapsReady) {
      this.googleMapsReadyInterval = setInterval(() => {
        if (typeof window !== 'undefined' && window.google && window.google.maps) {
          clearInterval(this.googleMapsReadyInterval);
          this.googleMapsReadyInterval = null;
          this.setState({ googleMapsReady: true });
        }
      }, 300);
    }

    let intervaloMapa = setInterval(() => {
      try {
        if (this.state.loop === 0) {
          this.setState({ loop: 1 });
          let grupo = getConfig('grupo');

          // Se módulo pluviométrico está desabilitado, sempre usar modo fases
          const modoPluviometrico =
            this.props.config &&
            this.props.config.modulo_pluviometrico &&
            this.state.tipoVisualizacao === 'pluviometrico';

          if (modoPluviometrico) {
            // Se está no modo pluviométrico, atualiza dados de chuva
            this.props
              .getPluviometroMapaData(grupo)
              .then(response => {
                const novosDados = response.payload.data || [];

                // Implementar lógica de "hold" para evitar mudanças bruscas
                const dadosProcessados = this.processarDadosPluviometricos(novosDados);

                this.setState({
                  pluviometroDataAnterior: this.state.pluviometroData, // Salvar dados anteriores
                  pluviometroData: dadosProcessados,
                  loop: 0,
                });
              })
              .catch(() => {
                this.setState({ loop: 0 });
              });
          } else {
            // Se está no modo normal, atualiza dados dos semáforos
            this.props
              .getControladorCoresGF(grupo)
              .then(response => {
                this.setState({ loop: 0 });
              })
              .catch(error => {
                this.setState({ loop: 0 });
              });
          }
        }
      } catch (error) {}
    }, 1000);

    this.setState({ intervaloMapaFaseGeral: intervaloMapa });

    this.blinkInterval = setInterval(() => {
      this.setState(prev => ({ blinkOn: !prev.blinkOn }));
    }, 600);
  }

  componentWillUnmount() {
    clearInterval(this.state.intervaloMapaFaseGeral);
    clearInterval(this.blinkInterval);
    if (this.googleMapsReadyInterval) {
      clearInterval(this.googleMapsReadyInterval);
    }
    if (this._panoramaListener && window.google && window.google.maps) {
      window.google.maps.event.removeListener(this._panoramaListener);
    }
  }

  onMapLoad(mapRef) {
    if (!mapRef) return;
    try {
      const panorama = mapRef.getStreetView();
      this._panoramaListener = window.google.maps.event.addListener(panorama, 'visible_changed', () => {
        this.setState({ isStreetView: panorama.getVisible(), selectedMarkerData: null });
      });
    } catch (e) {}
  }

  handleToggleOpen(markerId, controladorId, faseId, data) {
    this.setState({
      openInfoWindowMarkerId: markerId,
      selectedMarkerData: data || null,
    });
  }

  handleToggleClose() {
    this.setState({
      openInfoWindowMarkerId: '',
      selectedMarkerData: null,
    });
  }

  renderInfoRow(label, value, icon, valueClassName = '') {
    if (value === undefined || value === null || value === '') return null;

    return (
      <div className="mapa-fases-info-row">
        <span className="mapa-fases-info-row-label">{label}</span>
        <span className={`mapa-fases-info-row-value ${valueClassName}`}>{value}</span>
      </div>
    );
  }

  renderInfoWindow(data, position = null) {
    // Se módulo pluviométrico está desabilitado, sempre usar modo fases
    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';

    const planoAtual =
      data.plano_atu || (data.plano_id !== undefined && data.plano_id !== null ? `${data.plano_id}` : '');
    const proximoPlano = data.plano_pro || data.hora_proximo_plano || '';

    // InfoWindow específica para modo pluviométrico
    if (modoPluviometrico) {
      const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
      const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';
      const chuva = `${parseFloat(data.chuva_display || data.chuva_15min || 0).toFixed(2)}mm`;
      const periodo = data.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min';

      return (
        <InfoWindow
          position={position || { lat: parseFloat(data.fase_latitude), lng: parseFloat(data.fase_longitude) }}
          onCloseClick={() => this.handleToggleClose()}
        >
          <div className="mapa-fases-info-window">
            <div className="mapa-fases-info-header">
              <div>
                <strong>Controlador {data.numero_controlador}</strong>
                <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
              </div>
            </div>
            <div className="mapa-fases-info-body">
              {this.renderInfoRow('Endereço', data.endereco || 'Não informado', 'fa-map-marker')}
              {this.renderInfoRow('Chuva', chuva, 'fa-tint', 'is-highlight')}
              {this.renderInfoRow('Período', periodo, 'fa-clock-o')}
              {this.renderInfoRow('Latitude', data.fase_latitude, 'fa-location-arrow')}
              {this.renderInfoRow('Longitude', data.fase_longitude, 'fa-location-arrow')}
            </div>
          </div>
        </InfoWindow>
      );
    }

    // InfoWindow padrão para modo fases
    const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
    const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';
    const tipoControlador = parseInt(data.tipo) !== 1 ? 'Travessia de Pedestre' : 'Semafórico';

    return (
      <InfoWindow onCloseClick={() => this.handleToggleClose()}>
        <div className="mapa-fases-info-window">
          <div className="mapa-fases-info-header">
            <div>
              <strong>Controlador {data.numero_controlador}</strong>
              <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
            </div>
          </div>
          <div className="mapa-fases-info-body">
            {this.renderInfoRow('Tipo', tipoControlador, 'fa-road', parseInt(data.tipo) !== 1 ? 'is-highlight' : '')}
            {this.renderInfoRow('Endereço', data.controlador_endereco || 'Não informado', 'fa-map-marker')}
            {this.renderInfoRow('Anel', data.anel, 'fa-circle-o')}
            {this.renderInfoRow('Fase', data.fase_id, 'fa-random')}
            {this.renderInfoRow('IP', data.controlador_ip, 'fa-wifi')}
            {this.renderInfoRow('Porta', data.controlador_porta, 'fa-plug')}
            {planoAtual ? this.renderInfoRow('Plano Atual', planoAtual, 'fa-clock-o', 'is-highlight') : null}
            {proximoPlano ? this.renderInfoRow('Próximo Plano', proximoPlano, 'fa-forward') : null}
            {this.renderInfoRow('Latitude', data.fase_latitude, 'fa-location-arrow')}
            {this.renderInfoRow('Longitude', data.fase_longitude, 'fa-location-arrow')}
          </div>
          {data.croqui_file_id && (
            <div className="mapa-fases-info-actions">
              <Button
                onClick={() => downloadCroqui(data.croqui_file_id)}
                bsSize="xsmall"
                className="mapa-fases-info-download"
              >
                Baixar croqui
              </Button>
            </div>
          )}
        </div>
      </InfoWindow>
    );
  }

  renderMarker() {
    // Se módulo pluviométrico está desabilitado, sempre usar modo fases
    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';

    // Se está no modo pluviométrico, usar dados pluviométricos
    let list = modoPluviometrico ? this.state.pluviometroData : this.props.list || [];

    // No modo pluviométrico, agrupar por controlador (apenas 1 nuvem por localização)
    if (modoPluviometrico) {
      const controladorMap = {};
      list.forEach(item => {
        const controladorId = item.controlador_id;
        if (!controladorMap[controladorId] || item.anel === 1) {
          // Priorizar anel 1 ou primeiro encontrado
          controladorMap[controladorId] = item;
        }
      });
      list = Object.values(controladorMap);
    }

    let markers = [];
    let position = {};

    for (var key in list) {
      let objQuantidadeLatLon = [];
      if (list[key].quantidade_lat_lon != null && list[key].quantidade_lat_lon.length) {
        objQuantidadeLatLon = JSON.parse(list[key].quantidade_lat_lon);
      }

      if (list[key].fase_latitude != null) {
        position = { lat: parseFloat(list[key].fase_latitude), lng: parseFloat(list[key].fase_longitude) };
      }

      // Se não declarar as variáveis não funciona no onClickMarker
      let controlador_id = list[key].controlador_id;
      let fase_id = list[key].fase_id;

      let icon_cor = parseInt(list[key].tipo) === 1 ? ImgFaseGrey : ImgPedestrianGrey; // Cor padrão = cinza
      let isCloudIcon = false;

      // Controlador sem conexão (status_conexao > 1) nunca deve exibir cor viva:
      // a cor só vem de leitura ao vivo/cache, mas o status é a fonte de verdade.
      const offline = parseInt(list[key].status_conexao) > 1;

      // Se está no modo pluviométrico, usar ícone de nuvem
      if (modoPluviometrico) {
        isCloudIcon = true;
        // No modo pluviométrico, o ícone será renderizado como CloudIcon
      } else if (offline) {
        // Mantém cinza (padrão) - sem conexão
      } else {
        // Lógica normal para semáforos
        if (list[key].mod_piscante) {
          icon_cor = parseInt(list[key].tipo) === 1 ? GifTrafficYellowBlink : GifPedestrianRedBlink;
        } else if (list[key].fase_cor === 'Vermelho') {
          icon_cor = parseInt(list[key].tipo) === 1 ? ImgFaseRed : ImgPedestrianRed;
        } else if (list[key].fase_cor === 'Amarelo') {
          icon_cor = parseInt(list[key].tipo) === 1 ? ImgFaseYellow : ImgPedestrianYellow;
        } else if (list[key].fase_cor === 'Verde') {
          icon_cor = parseInt(list[key].tipo) === 1 ? ImgFaseGreen : ImgPedestrianGreen;
        }
      }

      // No modo pluviométrico, usar apenas uma posição por controlador
      if (modoPluviometrico) {
        let contKey = `${controlador_id}`;
        markers.push(this.newMarker(contKey, position, icon_cor, controlador_id, fase_id, list[key], isCloudIcon));
      } else {
        // Modo fases normal - usar múltiplas posições se disponível
        if (objQuantidadeLatLon.length) {
          for (const idx in objQuantidadeLatLon) {
            let contKey = `${controlador_id}_${fase_id}_${idx}`;
            position = {
              lat: parseFloat(objQuantidadeLatLon[idx].latitude),
              lng: parseFloat(objQuantidadeLatLon[idx].longitude),
            };

            // Usar setas específicas desta posição
            let iconParaPosicao = icon_cor;
            let markerShape = undefined;
            const setasDaPosicao = parseSetasValue(list[key].setas, parseInt(idx));
            if (!modoPluviometrico && !isCloudIcon && setasDaPosicao.length > 0) {
              let corFase = offline ? 'Apagado' : list[key].fase_cor || 'Apagado';
              if (!offline && list[key].mod_piscante) {
                const isPed = parseInt(list[key].tipo) !== 1;
                const corPiscante = isPed ? 'Vermelho' : 'Amarelo';
                corFase = this.state.blinkOn ? corPiscante : 'Apagado';
              }
              const isPed = parseInt(list[key].tipo) !== 1;
              const arrowIcon = getArrowIcon(setasDaPosicao, corFase, this.state.mapZoom, isPed);
              if (arrowIcon) {
                iconParaPosicao = arrowIcon;
                markerShape = getArrowMarkerShape(this.state.mapZoom);
              }
            }

            markers.push(
              this.newMarker(
                contKey,
                position,
                iconParaPosicao,
                controlador_id,
                fase_id,
                list[key],
                isCloudIcon,
                markerShape,
              ),
            );
          }
        } else {
          let contKey = `${controlador_id}_${fase_id}`;

          // Fase sem quantidade - usar setas da posição 0
          let iconParaFase = icon_cor;
          let markerShape = undefined;
          const setasDaPosicao = parseSetasValue(list[key].setas, 0);
          if (!modoPluviometrico && !isCloudIcon && setasDaPosicao.length > 0) {
            let corFase = offline ? 'Apagado' : list[key].fase_cor || 'Apagado';
            if (!offline && list[key].mod_piscante) {
              const isPed = parseInt(list[key].tipo) !== 1;
              const corPiscante = isPed ? 'Vermelho' : 'Amarelo';
              corFase = this.state.blinkOn ? corPiscante : 'Apagado';
            }
            const isPed = parseInt(list[key].tipo) !== 1;
            const arrowIcon = getArrowIcon(setasDaPosicao, corFase, this.state.mapZoom, isPed);
            if (arrowIcon) {
              iconParaFase = arrowIcon;
              markerShape = getArrowMarkerShape(this.state.mapZoom);
            }
          }

          markers.push(
            this.newMarker(
              contKey,
              position,
              iconParaFase,
              controlador_id,
              fase_id,
              list[key],
              isCloudIcon,
              markerShape,
            ),
          );
        }
      }
    }

    return markers;
  }

  newMarker(contKey, position, icon_cor, controlador_id, fase_id, data, isCloudIcon = false, markerShape = undefined) {
    if (isCloudIcon && data.tem_dados_pluviometricos) {
      // Renderizar como CloudOverlay
      return (
        <CloudOverlay
          key={contKey}
          position={position}
          data={data}
          onClick={() => this.handleToggleOpen(contKey, controlador_id, fase_id, data)}
        >
          {this.state.openInfoWindowMarkerId === contKey && this.renderInfoWindow(data, position)}
        </CloudOverlay>
      );
    } else {
      return (
        <Marker
          key={contKey}
          position={position}
          icon={icon_cor}
          shape={markerShape}
          onClick={() => this.handleToggleOpen(contKey, controlador_id, fase_id, data)}
        >
          {this.state.openInfoWindowMarkerId === contKey && this.renderInfoWindow(data)}
        </Marker>
      );
    }
  }

  renderStreetViewTooltip() {
    const data = this.state.selectedMarkerData;
    if (!data) return null;

    const modoPluviometrico =
      this.props.config && this.props.config.modulo_pluviometrico && this.state.tipoVisualizacao === 'pluviometrico';
    const statusConexao = data.status_conexao <= 1 ? 'Conectado' : 'Sem Conexão';
    const statusClass = data.status_conexao <= 1 ? 'is-online' : 'is-offline';

    let content;
    if (modoPluviometrico) {
      const chuva = `${parseFloat(data.chuva_display || data.chuva_15min || 0).toFixed(2)}mm`;
      const periodo = data.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min';
      content = (
        <div className="mapa-fases-info-body">
          {this.renderInfoRow('Endereço', data.endereco || 'Não informado')}
          {this.renderInfoRow('Chuva', chuva, '', 'is-highlight')}
          {this.renderInfoRow('Período', periodo)}
          {this.renderInfoRow('Latitude', data.fase_latitude)}
          {this.renderInfoRow('Longitude', data.fase_longitude)}
        </div>
      );
    } else {
      const planoAtual =
        data.plano_atu || (data.plano_id !== undefined && data.plano_id !== null ? `${data.plano_id}` : '');
      const proximoPlano = data.plano_pro || data.hora_proximo_plano || '';
      const tipoControlador = parseInt(data.tipo) !== 1 ? 'Travessia de Pedestre' : 'Semafórico';
      content = (
        <>
          <div className="mapa-fases-info-body">
            {this.renderInfoRow('Tipo', tipoControlador, '', parseInt(data.tipo) !== 1 ? 'is-highlight' : '')}
            {this.renderInfoRow('Endereço', data.controlador_endereco || 'Não informado')}
            {this.renderInfoRow('Anel', data.anel)}
            {this.renderInfoRow('Fase', data.fase_id)}
            {this.renderInfoRow('IP', data.controlador_ip)}
            {this.renderInfoRow('Porta', data.controlador_porta)}
            {planoAtual ? this.renderInfoRow('Plano Atual', planoAtual, '', 'is-highlight') : null}
            {proximoPlano ? this.renderInfoRow('Próximo Plano', proximoPlano) : null}
            {this.renderInfoRow('Latitude', data.fase_latitude)}
            {this.renderInfoRow('Longitude', data.fase_longitude)}
          </div>
          {data.croqui_file_id && (
            <div className="mapa-fases-info-actions">
              <Button
                onClick={() => downloadCroqui(data.croqui_file_id)}
                bsSize="xsmall"
                className="mapa-fases-info-download"
              >
                Baixar croqui
              </Button>
            </div>
          )}
        </>
      );
    }

    return (
      <div
        style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          zIndex: 1000,
          borderRadius: '16px',
          boxShadow: '0 18px 45px rgba(15,23,42,0.2)',
          overflow: 'hidden',
          pointerEvents: 'auto',
        }}
      >
        <div className="mapa-fases-info-window">
          <div className="mapa-fases-info-header">
            <div>
              <strong>Controlador {data.numero_controlador}</strong>
              <span className={`mapa-fases-info-status ${statusClass}`}>{statusConexao}</span>
            </div>
            <button
              onClick={this.handleToggleClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0 0 0 12px',
                fontSize: '20px',
                color: '#64748b',
                lineHeight: 1,
                alignSelf: 'flex-start',
              }}
            >
              ×
            </button>
          </div>
          {content}
        </div>
      </div>
    );
  }

  changeGrupo() {
    this.props.getConfControladorGrupoList();
    let grupo = getConfig('grupo');

    this.setState({ inicioMapa: { latitude: null, longitude: null } });

    // Carregar coordenadas do mapa
    this.props.getInicioMapa(grupo).then(response => {
      if (parseInt(response.payload.data.latitude) === 1) {
        swal({
          type: 'warning',
          title: 'Grupo físico sem controlador cadastrado!',
        });
      }
      this.setState({ inicioMapa: this.props.inicioMapa });
    });

    // Carregar controladores do novo grupo
    this.props.getControladorCoresGF(grupo);
  }

  handleZoomChanged(zoom) {
    if (zoom !== this.state.mapZoom) {
      arrowIconCache.clear();
      this.setState({ mapZoom: zoom });
    }
  }

  changeDisplayTraffic() {
    const traffic = this.state.displayTraffic;
    this.setState({ displayTraffic: !traffic });
  }

  changeVisualizacao(event) {
    const novoTipo = event.target.value;

    // Se módulo pluviométrico está desabilitado, não permitir mudança para pluviométrico
    if (novoTipo === 'pluviometrico' && (!this.props.config || !this.props.config.modulo_pluviometrico)) {
      return;
    }

    this.setState({ tipoVisualizacao: novoTipo });

    if (novoTipo === 'pluviometrico') {
      // Carregar dados pluviométricos
      const grupo = getConfig('grupo');
      this.props
        .getPluviometroMapaData(grupo)
        .then(response => {
          this.setState({ pluviometroData: response.payload.data || [] });
        })
        .catch(error => {
          this.setState({ tipoVisualizacao: 'fases' });
        });
    }
  }

  render() {
    let inicioMapa = this.state.inicioMapa;
    let hasValidCoordinates = inicioMapa.latitude && inicioMapa.longitude;

    return (
      <div className="mapa-fases-premium">
        <div
          className="mapa-fases-premium-toolbar"
          style={{
            background: '#ffffff',
            borderBottom: '1px solid #e9ecef',
            padding: '8px 15px',
            marginBottom: '10px',
          }}
        >
          <div
            className="mapa-fases-premium-toolbar-inner"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#2c3e50',
                  letterSpacing: '-0.3px',
                }}
              />
              <p
                style={{
                  margin: '2px 0 0 0',
                  fontSize: '12px',
                  color: '#6c757d',
                  fontWeight: '400',
                }}
              />
            </div>

            <div
              className="mapa-fases-premium-controls"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '6px',
              }}
            >
              <div
                className="mapa-fases-premium-filter"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <span
                  className="mapa-fases-premium-label"
                  style={{ fontSize: '12px', color: '#333', fontWeight: '500' }}
                >
                  Grupo Físico:
                </span>
                {this.state.tipoVisualizacao === 'pluviometrico' ? (
                  <SelectConfGrupoFisicoPluviometro
                    onChange={this.changeGrupo}
                    emptyText="Todos os Grupos"
                    customStyle={{
                      padding: '4px 8px',
                      fontSize: '13px',
                      fontWeight: '600',
                      border: '2px solid rgba(255,255,255,0.4)',
                      borderRadius: '4px',
                      backgroundColor: 'rgba(255,255,255,0.95)',
                      color: '#333',
                      cursor: 'pointer',
                      minWidth: '180px',
                      height: '32px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                  />
                ) : (
                  <SelectConfGrupoFisico
                    onChange={this.changeGrupo}
                    emptyText="Todos os Grupos"
                    customStyle={{
                      padding: '4px 8px',
                      fontSize: '13px',
                      fontWeight: '600',
                      border: '2px solid rgba(255,255,255,0.4)',
                      borderRadius: '4px',
                      backgroundColor: 'rgba(255,255,255,0.95)',
                      color: '#333',
                      cursor: 'pointer',
                      minWidth: '180px',
                      height: '32px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                  />
                )}
              </div>

              <div
                className="mapa-fases-premium-filter mapa-fases-premium-traffic"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <span
                  className="mapa-fases-premium-label"
                  style={{ fontSize: '12px', color: '#333', fontWeight: '500' }}
                >
                  Tráfego:
                </span>
                <label
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    width: '40px',
                    height: '20px',
                    margin: 0,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={this.state.displayTraffic}
                    onChange={this.changeDisplayTraffic}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      cursor: 'pointer',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: this.state.displayTraffic ? '#28a745' : '#ccc',
                      transition: '0.3s',
                      borderRadius: '20px',
                    }}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        content: '',
                        height: '16px',
                        width: '16px',
                        left: this.state.displayTraffic ? '22px' : '2px',
                        bottom: '2px',
                        backgroundColor: 'white',
                        transition: '0.3s',
                        borderRadius: '50%',
                      }}
                    />
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="mapa-fases-premium-content" style={{ padding: '0 10px', margin: '0' }}>
          <div
            className="mapa-fases-premium-layout"
            style={{
              display: 'flex',
              height: 'calc(100vh - 100px)',
              gap: '15px',
            }}
          >
            {/* Mapa principal */}
            <div
              className="mapa-fases-premium-map-card"
              style={{
                flex: 1,
                position: 'relative',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                overflow: 'hidden',
              }}
            >
              {!this.state.googleMapsReady ? (
                <div
                  className="mapa-fases-premium-empty"
                  style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                    color: '#6c757d',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <i
                      className="fa fa-spinner fa-spin"
                      style={{ fontSize: '42px', marginBottom: '20px', opacity: 0.6 }}
                    />
                    <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Carregando Google Maps</h4>
                    <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>Aguarde enquanto o mapa é preparado.</p>
                  </div>
                </div>
              ) : hasValidCoordinates ? (
                <MapaGoogle
                  containerElement={<div style={{ height: '100%', width: '100%' }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  defaultCenter={{ lat: inicioMapa.latitude, lng: inicioMapa.longitude }}
                  displayTraffic={this.state.displayTraffic}
                  onZoomChanged={this.handleZoomChanged}
                  onMapLoad={this.onMapLoad}
                >
                  {this.renderMarker()}
                </MapaGoogle>
              ) : (
                <div
                  className="mapa-fases-premium-empty"
                  style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                    color: '#6c757d',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <i className="fa fa-info-circle" style={{ fontSize: '48px', marginBottom: '20px', opacity: 0.5 }} />
                    <h4 style={{ fontWeight: '400', marginBottom: '8px' }}>Nenhum controlador cadastrado</h4>
                    <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                      Selecione outro grupo físico para visualizar os controladores no mapa.
                    </p>
                  </div>
                </div>
              )}
              {this.state.isStreetView && this.renderStreetViewTooltip()}
            </div>

            {/* Painel lateral pluviométrico - só aparece se módulo estiver habilitado */}
            {this.props.config &&
              this.props.config.modulo_pluviometrico &&
              this.state.tipoVisualizacao === 'pluviometrico' && (
                <div
                  className="mapa-fases-premium-rain-panel"
                  style={{
                    width: '300px',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e9ecef',
                    borderRadius: '4px',
                    padding: '15px',
                    overflowY: 'auto',
                  }}
                >
                  <h5
                    style={{
                      marginBottom: '20px',
                      color: '#495057',
                      fontWeight: '500',
                      fontSize: '16px',
                      borderBottom: '1px solid #f1f3f4',
                      paddingBottom: '12px',
                    }}
                  >
                    <i className="fa fa-cloud-rain" style={{ marginRight: '8px', color: '#6c757d' }} />
                    Análise Pluviométrica (15min)
                  </h5>
                  {/* Legenda de intensidades */}
                  <div style={{ marginBottom: '20px' }}>
                    <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Intensidade da Chuva</h6>
                    <div style={{ fontSize: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <i
                          className="fa fa-sun"
                          style={{
                            fontSize: '16px',
                            color: '#FFD700',
                            marginRight: '8px',
                            width: '20px',
                            textAlign: 'center',
                          }}
                        />
                        <span>Sem Chuva: 0mm (Sol)</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#90EE90',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Fraca: 0.1 - 1.25mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FFD700',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Moderada: 1.25 - 6.25mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FF8C00',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Forte: 6.25 - 12.5mm</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <div
                          style={{
                            width: '20px',
                            height: '15px',
                            backgroundColor: '#FF0000',
                            marginRight: '8px',
                            border: '1px solid #ccc',
                          }}
                        />
                        <span>Muito Forte: {'>'} 12.5mm</span>
                      </div>
                    </div>
                  </div>

                  {/* Resumo dos dados */}
                  {this.state.pluviometroData.length > 0 &&
                    (() => {
                      // Agrupa controladores únicos para o resumo
                      const controladoresUnicos = this.state.pluviometroData.reduce((acc, item) => {
                        const existing = acc.find(x => x.numero_controlador === item.numero_controlador);
                        if (!existing) {
                          acc.push(item);
                        } else {
                          // Mantém o maior valor de chuva se houver múltiplos anéis
                          if (item.chuva_15min > existing.chuva_15min) {
                            Object.assign(existing, item);
                          }
                        }
                        return acc;
                      }, []);

                      return (
                        <div>
                          <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>
                            Resumo dos Dados
                          </h6>
                          <div
                            style={{
                              fontSize: '12px',
                              backgroundColor: 'white',
                              padding: '10px',
                              borderRadius: '4px',
                              border: '1px solid #dee2e6',
                            }}
                          >
                            <div>
                              <strong>Total de controladores:</strong> {controladoresUnicos.length}
                            </div>
                            <div>
                              <strong>Com chuva ativa:</strong>{' '}
                              {controladoresUnicos.filter(d => (d.chuva_display || d.chuva_15min) > 0).length > 0
                                ? 'Sim'
                                : 'Não'}
                            </div>
                            <div>
                              <strong>Chuva máxima:</strong>{' '}
                              {Math.max(...controladoresUnicos.map(d => d.chuva_display || d.chuva_15min)).toFixed(2)}mm
                            </div>
                            <div>
                              <strong>Chuva média:</strong>{' '}
                              {(
                                controladoresUnicos.reduce((sum, d) => sum + (d.chuva_display || d.chuva_15min), 0) /
                                controladoresUnicos.length
                              ).toFixed(2)}
                              mm
                            </div>
                          </div>
                        </div>
                      );
                    })()}

                  {/* Lista de controladores */}
                  {this.state.pluviometroData.length > 0 && (
                    <div style={{ marginTop: '15px' }}>
                      <h6 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Controladores</h6>
                      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {this.state.pluviometroData
                          // Agrupa por controlador (remove duplicatas por anel)
                          .reduce((acc, item) => {
                            const existing = acc.find(x => x.numero_controlador === item.numero_controlador);
                            if (!existing) {
                              acc.push(item);
                            } else {
                              // Mantém o maior valor de chuva se houver múltiplos anéis
                              const itemChuva = item.chuva_display || item.chuva_15min;
                              const existingChuva = existing.chuva_display || existing.chuva_15min;
                              if (itemChuva > existingChuva) {
                                Object.assign(existing, item);
                              }
                            }
                            return acc;
                          }, [])
                          .sort((a, b) => (b.chuva_display || b.chuva_15min) - (a.chuva_display || a.chuva_15min))
                          .map((item, index) => (
                            <div
                              key={`controlador-${item.numero_controlador}`}
                              style={{
                                fontSize: '11px',
                                padding: '8px',
                                marginBottom: '5px',
                                backgroundColor: 'white',
                                border: '1px solid #dee2e6',
                                borderRadius: '3px',
                                borderLeft: `4px solid ${item.cor_intensidade}`,
                              }}
                            >
                              <div>
                                <strong>Controlador {item.numero_controlador}</strong>
                              </div>
                              <div>Chuva: {parseFloat(item.chuva_display || item.chuva_15min).toFixed(2)}mm</div>
                              <div style={{ fontSize: '10px', color: '#6c757d' }}>
                                {item.periodo_usado === '2min' ? 'Últimos 2min' : 'Últimos 15min'}
                              </div>
                              <div>Status: {item.status_conexao <= 1 ? 'Conectado' : 'Desconectado'}</div>
                              {item.ultima_leitura && (
                                <div style={{ fontSize: '10px', color: '#6c757d' }}>
                                  Última: {new Date(item.ultima_leitura).toLocaleTimeString()}
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  {this.state.pluviometroData.length === 0 && (
                    <div style={{ textAlign: 'center', color: '#6c757d', fontSize: '12px', marginTop: '20px' }}>
                      <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                      Nenhum controlador com pluviômetro encontrado
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.faseCad.listMap,
  controladorCoresGF: state.faseCad.listMap,
  inicioMapa: state.faseCad.inicioMapa,
  pluviometroMapaData: state.faseCad.pluviometroMapaData,
  config: state.auth.config,
  listGrupoFisicoPluviometro: state.selectdb.listGrupoFisicoPluviometro,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getControladorFase,
      getControladorCoresGF,
      getControladorCoresGT,
      getInicioMapa,
      getPluviometroMapaData,
      getConfControladorGrupoList,
      getGrupoFisicoPluviometroList,
      getConfControladorGrupoPluviometroList,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapaFaseGeral);
